
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'formControl': {'width': `300px`,'margin': `8px`,},'dropdownContainer': {'display': `flex`,'flexDirection': `column`,'alignItems': `center`,},'dayErrorContainer': {'display': `flex`,'margin': `1rem 0`,'padding': `0`,},'dayErrorText': {'fontFamily': `'Lato-Regular-Regular', sans-serif`,'color': `#8a1b2f`,},
        
      };
    };
  